import React from "react";
import { connect } from "react-redux";
import axios from "axios";

import LeftMenu from "../leftSideComponent/LeftSide";
import Header from "../headerComponent/Header";

import history from "../../auth/history";
import TotalBill from "./TotalBill";
import BillPaymentGraph from "./BillPaymentGraph";
import CashBackGraph from "./CashBackGraph";
import CalendarGraph from "./CalendarGraph";
import Footer from "../footerComponent/Footer";
import test from "./test";
import { store } from '../../redux/store';
import tokenErrorHandler from "../tokenErrorHandler";

import { selectedConsumerList, setSelectedAmount, totalActiveConsumers, totalConsumerNo, totalInActiveConsumers, totalInActives } from "../../redux/misc-data/misc-data.action";
const httpClient = axios.create();
class DashBoard extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			consumerList: [],
			toolBarVal: null,
			totalAmount: 0
		}
	}

	componentDidMount() {

		store.dispatch(selectedConsumerList([]));

		this.loadAllConsumer();

		setTimeout(() => {
			this.loadAllConsumerWithStartAndEndDte();
		}, 400);

	}

	loadAllConsumerWithStartAndEndDte() {
		store.dispatch(selectedConsumerList([]))
		store.dispatch(setSelectedAmount(0));
		var consumerList = [];
		var url = '/api/v1/billpay/corp/consumer/get-list/';
		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo,
			'role': this.props.clientRole
		}

		var value = (this.props.startDate != '' &&
			this.props.startDate != undefined &&
			this.props.startDate != null) ?
			'/' + this.props.startDate
			: '/all';

		var value1 = (this.props.endDate != '' &&
			this.props.endDate != undefined &&
			this.props.endDate != null) ?
			'/' + this.props.endDate
			: '/all'

		httpClient.get(url + this.props.agentInfo + value + value1,
			{ headers }
		).then((response) => {
			var totalAmount = 0;

			if (response.data != undefined) {
				if (response.data.length > 0) {

					response.data.map(res => {

						if (res.lastKnownStatus == "BILL_FETCH_SUCCESS"
							|| res.lastKnownStatus == "NO_FETCH_REQUIRED"
							|| res.lastKnownStatus == "CREATE_ORDER_FAILED"
							|| res.lastKnownStatus == "BILL_PAY_FAILED") {
							
							
							if (res.currentBillPayAmount != undefined &&
								res.currentBillPayAmount != null &&
								res.currentBillPayAmount != '' &&
								res.currentBillPayAmount != 'null' &&
								res.currentBillPayAmount > 0
							) {
								consumerList.push(res);
								totalAmount = totalAmount + res.currentBillPayAmount;
							}
						}

					})
				}
			}
			setTimeout(() => {
				store.dispatch(selectedConsumerList(consumerList));
				store.dispatch(setSelectedAmount(totalAmount));	
			}, 400);
			

		}).catch(error => {


			if (error.message.includes("401")) {
				tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
			}

		});


	}

	loadAllConsumer() {
		var totalActives = 0;
		var totalInactives = 0;

		var url = '/api/v1/billpay/corp/consumer/get-list/';
		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo,
			'role': this.props.clientRole
		}

		httpClient.get(url + this.props.agentInfo + '/all/all',
			{ headers }
		).then((response) => {

			this.setState({
				consumerList: response.data
			})



			if (response.data != undefined) {
				store.dispatch(totalConsumerNo(response.data.length));
			}

			var consumerList = [];
			if (response.data != undefined &&
				response.data.length > 0) {

				response.data.map(consumer => {


					if (consumer.active == true) {
						totalActives = totalActives + 1;
					} else {
						totalInactives = totalInactives + 1;
					}
				})

			}

			store.dispatch(totalActiveConsumers(totalActives));
			store.dispatch(totalInActiveConsumers(totalInactives));

			var totalAmount = 0;
			if (response.data != null &&
				response.data != undefined &&
				response.data != "") {
				response.data.map(res => {
					if (res.currentBillPayAmount != undefined &&
						res.currentBillPayAmount != null &&
						res.currentBillPayAmount > 0
					) {
						totalAmount = totalAmount + res.currentBillPayAmount;
					}
				})
				this.setState({
					totalAmount: totalAmount
				})
				

			} else {
				totalAmount = 0;

			}



		}).catch(error => {
			store.dispatch(totalConsumerNo(0));

			if (error.message.includes("401")) {
				tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
			}


		});
	}

	componentWillUnmount() {
	}


	render() {

		return (
			<div>
				<div class="main">
					<LeftMenu />
					<div class="right-side">
						<div class="container-fluid">
							<Header />
							<div class="row">
								<div class="col-12 col-lg-8 order-lg-2">
									<div class="card">

									
										<TotalBill />
										<CalendarGraph
											consumerList={this.state.consumerList}
											totalAmount={this.state.totalAmount} />

									</div>
								</div>

								<div class="col-12 col-lg-4 order-lg-1">
									<BillPaymentGraph />
									{/* <CashBackGraph /> */}
								</div>

							</div>
						</div>
					</div>
				</div>

				<Footer />
			</div>
		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage, loginErrorMessage },
		miscReduce: { phone, clientRole, agentInfo, startDate, endDate,token } }
) => ({
	errorMessage, loginErrorMessage, phone, clientRole, agentInfo, startDate, endDate,token
});

export default connect(mapStateToProps, null)(DashBoard);
